import { Component, inject, OnInit } from '@angular/core';
import { ContextService } from '../services/context.service';
import { SharedModule } from '../shared/shared.module';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  imports: [SharedModule],
  styles: [
    `
      h1 {
        color: red;
      }
      p {
        font-size: 16px;
      }
    `,
  ],
})
export class AccessDeniedComponent implements OnInit {
  private contextService = inject(ContextService);

  ngOnInit(): void {
    this.contextService.closeAllContextViews();
  }
}
